export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8011';

/* Every API request is wrapped in the function
 * which pulls the user token form session storage and adds it as an auth header
 */
export const setHeader = axios => {
  const token = sessionStorage.getItem('token');
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	// a BUNCH of places rely on this call throwing a full on error, and like, not handling it, but just execting to have the rest of the function not run -.-'
	// axios.defaults.validateStatus = (status) => {
	// 	return status <= 404
	// }
  return axios;
};
